import React from 'react'
import Spinner from './Spinner'

export default function SpinnerMessage({
  message,
}: {
  message?: string
}): JSX.Element {
  return (
    <div
      style={{
        position: 'absolute' as 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
      }}
    >
      <Spinner />
      {message && (
        <p style={{ marginTop: '100px', fontStyle: 'italic' }}>{message}</p>
      )}
    </div>
  )
}
